<template>
  <div
    v-if="isVisible"
    data-testid="footer-container"
    class="footer-box-shadow flex-row flex w-full fixed bottom-0 p-[16px] rounded-t-[24px] bg-white items-center md:py-[24px] md:px-[32px] z-[5]"
  >
    <!-- ******************** MOBILE VERSION ******************** -->
    <button
      v-if="isMobile"
      id="a-download-btn"
      data-testid="mobile-download-button"
      class="flex button-box-shadow button-style w-full rounded-[16px] justify-center items-center py-[12px] px-[24px] gap-[16px]"
      @click="openSuperRoute"
    >
      <div class="flex flex-row justify-center">
        <img
          data-testid="mobile-download-image"
          class="w-[40px] h-[40px] rounded-[8px]"
          :src="downloadIcon"
          alt="GO download icon"
        />
      </div>
      <div class="text-left">
        <p
          data-testid="mobile-th-download-title"
          class="font-krungsri text-[#292828] text-base font-bold"
        >
          ดาวน์โหลดเลย
        </p>
        <p
          data-testid="mobile-en-download-title"
          class="font-krungsri text-[#292828] text-sm font-normal"
        >
          Download GO by Krungsri Auto
        </p>
      </div>
    </button>
    <!-- ******************** TABLET/DESKTOP VERSION ******************** -->
    <div
      v-else
      data-testid="desktop-download-container"
      class="flex flex-row w-full justify-between"
    >
      <div class="flex flex-row items-center">
        <img
          data-testid="desktop-download-image"
          class="w-[48px] h-[48px] rounded-[8px]"
          :src="downloadIcon"
          alt="download icon"
        />
        <div class="text-left flex flex-col gap-[4px] ml-[16px]">
          <p
            data-testid="desktop-th-download-title"
            class="font-krungsri text-[#292828] text-base font-bold"
          >
            GO by Krungsri Auto ดาวน์โหลดเลย
          </p>
          <p
            data-testid="desktop-en-download-title"
            class="font-krungsri text-[#292828] text-sm font-medium"
          >
            แอปพลิเคชันเพื่อไลฟ์สไตล์ผู้ใช้รถ Download on the App Store
          </p>
        </div>
      </div>
      <img
        data-testid="desktop-qrcode-image"
        class="w-[64px] h-[64px]"
        :src="qrCode"
        alt="qr-code"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { SuperRouteUtil } from "#build/imports";
import qrCode from "@/assets/images/footer_qr_code.png";
import downloadIcon from "@/assets/images/go_logo.png";
import "@/assets/styles/footer.css";
export default {
  name: "AutoClubFooter",
  data() {
    return {
      isMobile: false,
      downloadIcon,
      isButtonActive: false,
      isVisible: false,
      qrCode,
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    this.isVisible = true;
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    openSuperRoute() {
      // TODO Move to util
      const route = useRoute();
      const url = new SuperRouteUtil().getSuperRoute(route.params);
      window.open(url, "_blank");
      window.location.assign(import.meta.env.VITE_SUPERROUTE_BASE_URL);
    },
  },
};
</script>
